app.directive('pendingTradeItem', [
    function () {
        return {
            restrict: 'E',
            templateUrl: 'templates/directives/pendingTrade.html'
        }
    }]);